import React from 'react';
import { DistrictNeedsAssessment } from '@/components/landing/DistrictNeedsAssessment';

export default function RFPGuidePage() {
  return (
    <div className="container mx-auto py-8 space-y-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">District Needs Assessment</h1>
        <p className="text-muted-foreground">
          Analyze your district's professional development requirements with AI-powered insights
        </p>
      </div>
      <DistrictNeedsAssessment />
    </div>
  );
}